// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: peer/peer_role.proto

/* eslint-disable */

export const protobufPackage = "peer";

export enum PeerRole {
  PEER_ROLE_UNSPECIFIED = 0,
  PEER_ROLE_HOST = 1,
  PEER_ROLE_AUDIENCE = 2,
  UNRECOGNIZED = -1,
}

export function peerRoleFromJSON(object: any): PeerRole {
  switch (object) {
    case 0:
    case "PEER_ROLE_UNSPECIFIED":
      return PeerRole.PEER_ROLE_UNSPECIFIED;
    case 1:
    case "PEER_ROLE_HOST":
      return PeerRole.PEER_ROLE_HOST;
    case 2:
    case "PEER_ROLE_AUDIENCE":
      return PeerRole.PEER_ROLE_AUDIENCE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PeerRole.UNRECOGNIZED;
  }
}

export function peerRoleToJSON(object: PeerRole): string {
  switch (object) {
    case PeerRole.PEER_ROLE_UNSPECIFIED:
      return "PEER_ROLE_UNSPECIFIED";
    case PeerRole.PEER_ROLE_HOST:
      return "PEER_ROLE_HOST";
    case PeerRole.PEER_ROLE_AUDIENCE:
      return "PEER_ROLE_AUDIENCE";
    case PeerRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
